import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "utils/axiosInstance";

export const useGetCustomerWalletActivitiesQuery = ({ id }: { id: any }) => {
  return useQuery({
    queryKey: ["getCustomerWalletActivitiesQuery", id],
    queryFn: () =>
      axiosInstance
        .get(`/customers/${id}/wallet/transactions`)
        .then((res) => res.data),
  });
};
